import { render, staticRenderFns } from "./CardPropertyNumber.vue?vue&type=template&id=544cd78e&scoped=true&"
import script from "./CardPropertyNumber.vue?vue&type=script&lang=js&"
export * from "./CardPropertyNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544cd78e",
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign({QInput}, component.options.components || {})
